import classNames from 'clsx';
import React, { useContext } from 'react';

import Translation from '@swf/components/Translation/Translation';
import type { TrackedTranslation } from '@swf/core/types/i18n';

import CreateTournamentContext from '../CreateTournamentContext/CreateTournamentContext';
import Chevron from '../assets/chevron.svg';
import useWizardNav from '../hooks/useWizardNav';
import { ModalPages, ModalPagesNames, ModalPagesRoutes, totalPages } from '../utils/common';

import {
  TXTCLI_Game_Details,
  TXTCLI_More_Details,
  TXTWCL_Main_Info
} from './Breadcrumbs.messages.json';
import styles from './Breadcrumbs.scss';

interface BreadcrumbsItem {
  pageName: string | ModalPages;
  translation: TrackedTranslation;
}

interface Props {
  breadcrumbs?: BreadcrumbsItem[];
}

const translations = [TXTWCL_Main_Info, TXTCLI_Game_Details, TXTCLI_More_Details];

const pages: BreadcrumbsItem[] = ModalPagesNames.map((page, index) => ({
  pageName: page,
  translation: translations[index]
}));

const Breadcrumbs: React.FC<Props> = ({ breadcrumbs = pages }) => {
  const {
    state: { activePage }
  } = useContext(CreateTournamentContext);
  const goTo = useWizardNav(activePage, totalPages);

  return (
    <div className={styles.breadcrumbs}>
      {breadcrumbs.map(({ translation, pageName }, index) => {
        const isLast = index + 1 === breadcrumbs.length;
        const isActive = activePage === ModalPages[pageName];
        return (
          <React.Fragment key={pageName}>
            <div
              className={classNames(styles.breadcrumbsItem, { [styles.active]: isActive })}
              onClick={() => goTo(ModalPages[pageName], ModalPagesRoutes[index])}
            >
              <span>
                <Translation {...translation} />
              </span>
            </div>
            {!isLast && <Chevron />}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default Breadcrumbs;
